export default __webpack_public_path__ + "static/media/41t.1a545cb4.jpg";